export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10">
      <div className="pointer-events-none absolute inset-x-0 -bottom-10 flex justify-center opacity-[0.05] sm:-bottom-16">
        <img src="/logo-full.png" alt="" className="w-[720px] max-w-none" />
      </div>

      <div className="relative mx-auto flex max-w-7xl flex-col gap-10 px-6 py-16 sm:px-12 sm:py-20 lg:px-16">
        <div>
          <img src="/logo-full.png" alt="AxenLabs" className="h-7 w-auto" data-testid="footer-logo" />
          <p className="mt-6 max-w-sm text-xs font-light leading-relaxed text-neutral-500">
            Research-grade peptide formulations. For research and laboratory
            use only — not for human or veterinary consumption.
          </p>
        </div>

        <div className="flex flex-col justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600" data-testid="footer-copyright">
            © 2026 AxenLabs Research Inc. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600">
            Batch 01 — November 2026
          </p>
        </div>
      </div>
    </footer>
  );
}
